// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"18":"product","32":"HomeView","49":"join","631":"contact","678":"AboutView"}[chunkId] || chunkId) + "." + {"18":"24183f65","32":"016acbe5","49":"1383110a","259":"984bac62","408":"098bace2","473":"b53557f6","631":"8783827a","678":"36accad8","743":"f794450a","804":"aa674304","914":"7dd62f2a"}[chunkId] + ".js";
};